import type { CarwashModeState } from "../../config/carwashMode";
import { NightAiScenarioIcon } from "./NightAiScenarioIcon";
import "./NightCards.css";

interface NightCarwashModeCardProps {
  session: CarwashModeState;
  onConfirm: () => void;
  onDismiss: () => void;
}

export function NightCarwashModeCard({
  session,
  onConfirm,
  onDismiss
}: NightCarwashModeCardProps) {
  if (session.stage === "idle") {
    return null;
  }

  const isActive = session.stage === "active";
  const title = isActive ? "洗车模式已开启" : "建议开启洗车模式";
  const description = isActive
    ? "车窗已关闭，外后视镜已收起，空调已切换内循环。"
    : `已到达${session.shopName}，是否为您开启洗车模式？`;

  return (
    <section className={`night-carwash-mode-card night-carwash-mode-card--${session.stage}`} aria-label={title}>
      <span className="night-carwash-mode-card__surface" aria-hidden="true" />
      <span className="night-ai-scenario-icon night-ai-scenario-icon--wash night-carwash-mode-card__icon">
        <NightAiScenarioIcon icon="wash" />
      </span>

      <div className="night-carwash-mode-card__main">
        <h2>{title}</h2>
        <p>{description}</p>
      </div>

      <div className="night-carwash-mode-card__actions">
        <button
          type="button"
          className="night-carwash-mode-card__action night-carwash-mode-card__action--primary"
          onClick={isActive ? onDismiss : onConfirm}
        >
          {isActive ? "知道了" : "开启洗车模式"}
        </button>
        <button
          type="button"
          className="night-carwash-mode-card__action night-carwash-mode-card__action--secondary"
          onClick={onDismiss}
        >
          {isActive ? "收起" : "稍后"}
        </button>
      </div>
    </section>
  );
}
